import { useState, useMemo } from "react";
import { Panel, Label } from "@/components/SplitLayout";

export default function WordCounter() {
  const [text, setText] = useState("");

  const stats = useMemo(() => {
    const trimmed = text.trim();
    const words = trimmed ? trimmed.split(/\s+/).length : 0;
    const chars = text.length;
    const charsNoSpace = text.replace(/\s/g, "").length;
    const sentences = trimmed ? (trimmed.match(/[.!?]+(\s|$)/g) || []).length || (trimmed ? 1 : 0) : 0;
    const paragraphs = trimmed ? trimmed.split(/\n+/).filter((p) => p.trim()).length : 0;
    const readMin = Math.max(words ? 1 : 0, Math.ceil(words / 200));
    return { words, chars, charsNoSpace, sentences, paragraphs, readMin };
  }, [text]);

  const cards = [
    { label: "Words", value: stats.words },
    { label: "Characters", value: stats.chars },
    { label: "No Spaces", value: stats.charsNoSpace },
    { label: "Sentences", value: stats.sentences },
    { label: "Paragraphs", value: stats.paragraphs },
    { label: "Read Time", value: `${stats.readMin}m` },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-2">
        <Label>Your text</Label>
        <textarea
          data-testid="word-counter-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Start typing or paste your text here..."
          className="h-[420px] w-full resize-none border border-border bg-card p-5 text-sm leading-relaxed outline-none focus:ring-2 focus:ring-primary"
        />
      </div>
      <div className="lg:sticky lg:top-24 lg:self-start">
        <Panel title="Live statistics" testId="word-counter-output">
          <div className="grid grid-cols-2 gap-px bg-border sm:grid-cols-3">
            {cards.map((c) => (
              <div
                key={c.label}
                data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}
                className="bg-card p-5"
              >
                <div className="font-display text-3xl font-extrabold tracking-tighter text-primary">
                  {c.value}
                </div>
                <div className="mt-1 text-xs font-bold uppercase tracking-[0.12em] text-muted-foreground">
                  {c.label}
                </div>
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
